/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { Button, ButtonProps, theme } from "@nordcloud/gnui";

const Wrapper = styled.footer`
  margin: 0 -${theme.spacing.spacing04};
  display: flex;
  align-items: center;
  padding: ${theme.spacing.spacing04};
  border-top: 1px solid ${theme.color.border.border01};
  position: relative;
`;

type Props = {
  onPrevClick?: () => void;
  nextButtonProps?: ButtonProps;
};

export function FormWizardFooter({ onPrevClick, nextButtonProps }: Props) {
  const { children = "Next Step", ...rest } = nextButtonProps ?? {};
  return (
    <Wrapper css={{ justifyContent: "center" }}>
      {onPrevClick && (
        <Button
          icon="arrowLeft"
          type="button"
          severity="medium"
          css={{
            position: "absolute",
            left: theme.spacing.spacing04,
            top: "50%",
            transform: "translateY(-50%)",
            borderColor: "transparent",
          }}
          onClick={onPrevClick}
        >
          Previous Step
        </Button>
      )}
      <Button iconRight icon="arrowRight" type="submit" {...rest}>
        {children}
      </Button>
    </Wrapper>
  );
}
